export default __webpack_public_path__ + "static/media/sprint3.c0d77f1e.jpg";